import React from 'react';

export default (props) => (
  <svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
    <title>phone</title>
    <path  d="M3.41,6.19A10.12,10.12,0,0,0,7.8,10.58L9.27,9.12A.66.66,0,0,1,10,9a7.7,7.7,0,0,0,2.38.38A.67.67,0,0,1,13,10v2.33a.67.67,0,0,1-.67.67h0A11.33,11.33,0,0,1,1,1.67H1A.67.67,0,0,1,1.67,1H4a.67.67,0,0,1,.67.67h0A7.63,7.63,0,0,0,5,4a.66.66,0,0,1-.17.68Z" transform="translate(-1 -1)"/>
  </svg>
);


// WEBPACK FOOTER //
// ./src/components/svg/phone.js